import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Spin, message } from 'antd';

import RightImageComponent from './right_image_component'
import AuthFooterComponent from './footer_component'
import AuthenticationService from '../../service/authentication_service';
import UrlService from '../../service/url_service';

class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
            loading: false
        };
    }
    componentDidMount(){
        if(AuthenticationService.getToken()){
            this.props.history.push("/dashboard");
        }
    }

    logout = () => {
        AuthenticationService.clearLocalstorage();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

    }

    login = () => {

        this.setState({ loading: true });

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Basic dWF1dGhfZmMwMTE0MjcxYzRlNWYxODp4c2VjYzk1MjM3ODUyMQ==");
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("username", this.state.username);
        urlencoded.append("password", this.state.password);
        urlencoded.append("grant_type", "password");
        urlencoded.append("client_id", "uauth_fc0114271c4e5f18");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };


        fetch(UrlService.BASE_PATH + "/oauth/token", requestOptions)
            .then(response => {
                return response.json();

            })
            .then(result => {
                // console.log(result);
                if (result && result.error) {
                    message.error(result.error_description);
                    this.setState({ loading: false });
                } else {
                    AuthenticationService.setToken(result.access_token);
                    AuthenticationService.setEmail(result.email);
                    AuthenticationService.setUserId(result.userId);
                    AuthenticationService.setName(result.name);
                    AuthenticationService.setMobileNumber(result.mobileNumber);
                    AuthenticationService.setUsername(result.username);
                    AuthenticationService.setImage(result.photo);

                    setTimeout(this.props.history.push("/dashboard"), 2000);
                    
                }

            })
            .catch(error => console.log('error', error));


    }
    render() {
        const { loading } = this.state;
        return (
            <div className="page-ath-wrap">
                <div className="page-ath-content">
                    <div className="page-ath-header"><a href="/" className="page-ath-logo"><img src="/assets/images/logo.png" srcSet="/assets/images/logo.png 2x" alt="logo" /></a></div>
                    <Spin spinning={loading}>
                        <div className="page-ath-form">
                            <h2 className="page-ath-heading">Sign in <small>to your Account</small></h2>
                            <form onSubmit={e => e.preventDefault()} >
                                <div className="input-item"><input type="text" onChange={this.handleChange} placeholder="Your username" className="input-bordered" name="username" /></div>
                                <div className="input-item"><input type="password" onChange={this.handleChange} placeholder="Password" className="input-bordered" name="password" /></div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="input-item text-left"><input className="input-checkbox input-checkbox-md" id="remember-me" type="checkbox" /><label htmlFor="remember-me">Remember Me</label></div>
                                    <div>
                                        <Link to="/forgot-password">Forgot password?</Link>
                                        <div className="gaps-2x" />
                                    </div>
                                </div>
                                <button className="btn btn-primary btn-block" onClick={this.login}>Sign In</button>
                            </form>
                            
                            <div className="gaps-2x" />
                            <div className="gaps-2x" />
                            <div className="form-note">Don’t have an account? <Link to="/signup"> <strong>Sign up here</strong></Link></div>
                        </div>
                    </Spin>
                    <AuthFooterComponent />
                </div>
                <RightImageComponent image="/assets/images/logo.png" />
            </div>
        );
    }
}

export default withRouter(LoginPage);
